import React, { FC, ReactNode } from "react";
import { Bold } from "../Bold/Bold";
import { Box, BoxProps } from "../Box/Box";
import { StackProps, VStack } from "../Stack/Stack";

export interface DetailsListProps extends Omit<StackProps, "title"> {
  title?: ReactNode;
  children: ReactNode;
}

export const DetailsList: FC<DetailsListProps> = ({
  title,
  children,
  ...props
}) => {
  return (
    <VStack as="dl" alignItems="stretch" spacing="4" {...props}>
      {title && (
        <Box as="dt">
          <Bold>{title}</Bold>
        </Box>
      )}
      {children}
    </VStack>
  );
};

export type DetailsListItemProps = BoxProps;

export const DetailsListItem: FC<DetailsListItemProps> = ({
  children,
  ...props
}) => {
  return (
    <Box as="dd" {...props}>
      {children}
    </Box>
  );
};
